import React from 'react';
import { motion } from 'framer-motion';
export function TherapistPresentation() {
  return <section className="relative overflow-hidden bg-transparent" data-id="element-252" data-mp="2ackbzy14w6fv">
      <div className="w-full" data-id="element-253" data-mp="2aa6ivuq0l4ay">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.65,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-full" data-id="element-254" data-mp="2p1gg5k02kzb7">
          <img src="https://cdn.magicpatterns.com/uploads/gaG6TmHU7fS36gXwakgWLq/hf_20260519_152853_ca2a79b4-e63f-414b-8afe-77ae1932ec07.webp" alt="Sofía Alondra - Creadora de la Guía de Tarot Terapéutico" className="block h-auto w-full" data-id="element-255" data-mp="1rd6dr3wdg9jk" />
        </motion.div>
      </div>
    </section>;
}